export default __webpack_public_path__ + "static/media/triangle-pattern_cri-060.77ebf7f3.jpg";